import ClientFilter from "./components/client-filter";

export default class CollectionList {
  static init() {
    ClientFilter.init();
  }
}
